module.exports = __webpack_public_path__ + "static/media/baseline-cloud_upload.64b32201.svg";